
// Input sanitization and validation utilities
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return '';
  
  // Remove potential XSS vectors
  return input
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<[^>]*>/g, '')
    .trim();
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) && email.length <= 254;
};

export const validateName = (name) => {
  return name && name.length >= 2 && name.length <= 100 && /^[a-zA-ZÀ-ÿ\s\-']+$/.test(name);
};

export const validateMessage = (message) => {
  return message && message.length >= 10 && message.length <= 2000;
};

export const rateLimitCheck = () => {
  const lastSubmission = localStorage.getItem('lastFormSubmission');
  const now = Date.now();
  
  if (lastSubmission && (now - parseInt(lastSubmission)) < 1000) {
    return false; // Rate limited - 1 second between submissions
  }
  
  localStorage.setItem('lastFormSubmission', now.toString());
  return true;
};
